import styled, { css } from 'styled-components'
import { ELanguage } from '../../../SearchResults/utils/language'

const smUp = '@media (min-width: 640px)'

export const SortBarExtraFilterRowsRoot = styled.div<{
    $isCompact: boolean
    $embedded: boolean
    $language: ELanguage
    $inlineDropdowns: boolean
}>`
    color: #333;

    ${({ $embedded, $isCompact }) =>
        $embedded
            ? css`
                  margin-top: 0;
                  padding-top: 0;
                  border: none;
              `
            : css`
                  margin-top: ${$isCompact ? '8px' : '12px'};
                  padding-top: ${$isCompact ? '8px' : '12px'};
                  border-top: 1px solid #e5e5e5;
              `}

    ${({ $embedded, $isCompact, $language }) =>
        $embedded &&
        !$isCompact &&
        css`
            width: max-content;
            max-width: min(100%, ${$language === ELanguage.VI ? '30rem' : '50rem'});
        `}

    .sbeef__inner {
        display: flex;
        flex-direction: column;
        gap: ${({ $isCompact }) => ($isCompact ? '8px' : '12px')};
        ${({ $embedded }) =>
            $embedded &&
            css`
                min-width: 0;
            `}
        ${({ $embedded, $isCompact }) =>
            $embedded &&
            $isCompact &&
            css`
                flex-direction: row;
                align-items: flex-end;
                gap: 8px;
            `}
    }

    .sbeef__row {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 0 !important;
        ${({ $embedded, $isCompact }) =>
            $embedded &&
            $isCompact &&
            css`
                min-width: 120px;
                flex-shrink: 0;
            `}

        ${smUp} {
            ${({ $embedded }) =>
                $embedded
                    ? css`
                          flex-direction: row;
                          align-items: center;
                          gap: 16px;
                          min-width: 0;
                      `
                    : css`
                          flex-direction: row;
                          align-items: center;
                          gap: 24px;
                      `}
        }
    }

    ${({ $inlineDropdowns }) =>
        $inlineDropdowns &&
        css`
            margin-top: 0;
            padding-top: 0;
            border: 0;

            .sbeef__inner {
                flex-direction: row;
                align-items: center;
                gap: 8px;
            }

            .sbeef__row {
                min-width: 0;
            }

            .sbeef__dropdown {
                width: auto;
            }

            .sbeef__dropdown-trigger {
                width: auto;
                min-width: 140px;
                height: 40px;
                padding: 0 14px;
                border-radius: 8px;
                border-color: #d8d8d8;
            }

            .sbeef__dropdown-trigger-text {
                font-weight: 400;
            }

            .sbeef__inline-clear {
                height: 40px;
                border: 0;
                background: transparent;
                color: #666;
                font-size: 14px;
                font-weight: 400;
                line-height: 1;
                padding: 0 4px;
                cursor: pointer;
                white-space: nowrap;
                outline:none !important;
            }

            .sbeef__inline-clear:hover:not(.sbeef__inline-clear--disabled) {
                color: #005aff;
            }

            .sbeef__inline-clear--disabled {
                color: #a3a3a3;
                cursor: default;
            }
        `}

    .sbeef__label {
        flex-shrink: 0;
        font-size: 13px;
        line-height: 1.25;

        ${smUp} {
            width: ${({ $language }) => ($language === ELanguage.VI ? '7rem' : '10rem')};
            flex-shrink: 0;
            text-align: left;
        }
    }

    .sbeef__chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        ${({ $embedded, $isCompact }) =>
            $embedded &&
            !$isCompact &&
            css`
                flex: 1 1 0;
                min-width: 0;
            `}
    }

    .sbeef__dropdown {
        width: 100%;
    }

    .sbeef__dropdown-trigger {
        width: 100%;
        height: 30px;
        border-radius: 9999px;
        border: 1px solid #c9c9c9;
        background: #fff;
        color: #333;
        padding: 0 14px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        text-align: left;
        cursor: pointer;
    }

    .sbeef__dropdown-trigger:hover:not(.sbeef__dropdown-trigger--active) {
        border-color: #80adff;
    }

    .sbeef__dropdown-trigger--active {
        border-color: rgb(0, 90, 255);
        color: rgb(0, 54, 153);
        background : rgb(239, 245, 255);
    }

    .sbeef__dropdown-trigger-text {
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
        white-space: nowrap;
    }

    .sbeef__dropdown-chevron {
        width: 12px;
        height: 12px;
        border-right: 2px solid #777;
        border-bottom: 2px solid #777;
        transform: rotate(45deg) translateY(-2px);
        transition: transform 0.2s ease;
        flex-shrink: 0;
    }

    .sbeef__dropdown-trigger--active .sbeef__dropdown-chevron {
        border-right-color: #005aff;
        border-bottom-color: #005aff;
    }

    .sbeef__dropdown-chevron--open {
        transform: rotate(-135deg) translateY(-1px);
    }

    .sbeef__dropdown-menu {
        border-radius: 20px;
        background: #fff;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
        overflow: hidden;
    }

    .sbeef__dropdown-menu-item {
        width: 100%;
        border: 0;
        border-top: 1px solid #e8e8e8;
        background: #fff;
        color: #333;
        text-align: left;
        padding: 15px 24px;
        font-size: 14px;
        line-height: 1.2;
        font-weight: 400;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .sbeef__dropdown-menu-item:first-child {
        border-top: 0;
    }

    .sbeef__dropdown-menu-item--active {
        background: #f5f5f5;
    }

    .sbeef__dropdown-item-check {
        width: 18px;
        min-width: 18px;
        text-align: center;
        font-size: 20px;
        line-height: 1;
        color: #666;
        opacity: 0;
    }

    .sbeef__dropdown-item-check--visible {
        opacity: 1;
    }

    .sbeef__chip {
        box-sizing: border-box;
        outline:none !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 9999px;
        border: 1px solid #e0e0e0;
        padding: 5px 12px;
        font-size: 12px;
        transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
        user-select: none;
        cursor: pointer;
        background: #fff;
        color: #333;

        &:not(.sbeef__chip--active):hover {
            border-color: #80adff;
            color: #005aff;
        }

        &.sbeef__chip--active {
            border: 1px solid rgba(0, 90, 255, 0.2);
            background: #ebf2ff;
            color: rgb(0, 90, 255);
        }

        &.sbeef__chip--active:hover {
            border-color: #005aff;
            color: rgb(0, 90, 255);
        }
    }

    ${({ $inlineDropdowns }) =>
        $inlineDropdowns &&
        css`
            .sbeef__dropdown-trigger {
                border-radius: 8px !important;
                height: 40px !important;
                outline:none !important;
            }
        `}
`
